"use client";

import { Card } from "./Card";
import { CardHeader, type CardHeaderProps } from "./CardHeader";
import { cn } from "@/lib/utils/cn";

export interface InfoCardProps extends Omit<CardHeaderProps, "className"> {
  children: React.ReactNode;
  bodyClassName?: string;
  className?: string;
}

export function InfoCard({
  icon,
  title,
  subtitle,
  isComplete,
  actions,
  children,
  bodyClassName,
  className,
}: InfoCardProps) {
  return (
    <Card padding="none" className={cn("overflow-hidden", className)}>
      <CardHeader
        icon={icon}
        title={title}
        subtitle={subtitle}
        isComplete={isComplete}
        actions={actions}
      />
      <div className={cn("p-4", bodyClassName)}>{children}</div>
    </Card>
  );
}
